export default "__VITE_ASSET__ea1c6cc7__"